import { render, staticRenderFns } from "./IngredientsModal.vue?vue&type=template&id=febc8e72&scoped=true&"
import script from "./IngredientsModal.vue?vue&type=script&lang=js&"
export * from "./IngredientsModal.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsModal.vue?vue&type=style&index=0&id=febc8e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc8e72",
  null
  
)

export default component.exports